export default __webpack_public_path__ + "static/photo5-1fc8133dba4fc7d735e1ba55185347ad.webp";